var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.parameters.expectation == "sql_assertion"
      ? _c("span", [_vm._v(_vm._s(_vm.parameters.value))])
      : _vm._e(),
    _vm.parameters.expectation == "statistic_range_expectation"
      ? _c("span", [
          _vm._v(
            _vm._s(
              "Min. " +
                _vm.parameters.min_value +
                ", Estrictamente: " +
                (_vm.parameters.min_value_strict ? "Si" : "No")
            )
          ),
        ])
      : _vm._e(),
    _vm.parameters.expectation == "statistic_range_expectation"
      ? _c("span", [
          _vm._v(
            _vm._s(
              "Max. " +
                _vm.parameters.max_value +
                ", Estrictamente: " +
                (_vm.parameters.max_value_strict ? "Si" : "No")
            )
          ),
        ])
      : _vm._e(),
    _vm.parameters.expectation == "statistic_range_expectation"
      ? _c("span", [_vm._v(_vm._s("Rango " + _vm.parameters.statistic_value))])
      : _vm._e(),
    _vm.parameters.expectation == "table_condition_expectation"
      ? _c("span", [_vm._v(_vm._s(_vm.parameters.value))])
      : _vm._e(),
    _vm.parameters.expectation == "range_expectation"
      ? _c("span", [
          _vm._v(
            _vm._s(
              "Min. " +
                _vm.parameters.min_value +
                ", Estrictamente: " +
                (_vm.parameters.min_value_strict ? "Si" : "No")
            )
          ),
        ])
      : _vm._e(),
    _vm.parameters.expectation == "range_expectation"
      ? _c("span", [
          _vm._v(
            _vm._s(
              "Max. " +
                _vm.parameters.max_value +
                ", Estrictamente: " +
                (_vm.parameters.max_value_strict ? "Si" : "No")
            )
          ),
        ])
      : _vm._e(),
    _vm.parameters.expectation == "set_expectation"
      ? _c("span", [_vm._v(_vm._s(_vm.parameters.set_value))])
      : _vm._e(),
    _vm.parameters.expectation == "row_condition_expectation"
      ? _c("span", [_vm._v(_vm._s(_vm.parameters.value))])
      : _vm._e(),
    _vm.parameters.expectation == "regex_expectation"
      ? _c("span", [_vm._v(_vm._s(_vm.parameters.value))])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }